<section class="reg-box">
  <div *ngIf="isRegistrationNotStarted" class="reg-err">
    <div class="reg-err-msg">Registrations are not yet started!</div>
    <div class="reg-err-help">
      For any questions, please email to
      <a href="mailto:thegrandstand21&#64;gmail.com"
        >thegrandstand21&#64;gmail.com</a
      >
    </div>
  </div>
  <div *ngIf="isRegistrationCompleted" class="reg-err">
    <div class="reg-err-msg">Registrations are closed!</div>
    <div class="reg-err-help">
      For any questions, please email to
      <a href="mailto:thegrandstand21&#64;gmail.com"
        >thegrandstand21&#64;gmail.com</a
      >
    </div>
  </div>
  <div *ngIf="isRegistrationStarted" class="h-100 d-flex flex-column">
    <div class="w-100 mb-auto scrollable d-flex flex-column">
      <div class="mb-3">
        <div class="d-flex justify-content-between align-items-center">
          <div [ngSwitch]="currentStep" class="steps-title">
            <div *ngSwitchCase="steps.ExhibitorInfo">Exhibitor Information</div>
            <div *ngSwitchCase="steps.Livestocks">Shows</div>
            <div *ngSwitchCase="steps.Disclosures">Disclosures</div>
            <div *ngSwitchCase="steps.Payment">Payment</div>
            <div *ngSwitchCase="steps.Confirmation">Confirmation</div>
          </div>
          <div class="text-end steps">
            <span class="current-step">Step {{ currentStep }}</span> of 5
          </div>
        </div>
        <p-progressBar
          [value]="getProgress()"
          class="progressbar mt-2"
        ></p-progressBar>
      </div>
      <div class="pt-2 scrollable" [ngSwitch]="currentStep">
        <app-exhibitor-info
          #exhibitorInfo
          *ngSwitchCase="steps.ExhibitorInfo"
          [states]="states"
          [orgId]="orgId"
          [registration]="registration"
          [counties]="counties"
          [orgConfigs]="orgConfigs"
        ></app-exhibitor-info>
        <app-livestocks
          #livestocksInfo
          *ngSwitchCase="steps.Livestocks"
          [orgId]="orgId"
          [registration]="registration"
        ></app-livestocks>
        <app-additional-info
          #additionalInfo
          *ngSwitchCase="steps.Disclosures"
          [registration]="registration"
        ></app-additional-info>
        <app-payment
          #paymentInfo
          *ngSwitchCase="steps.Payment"
          [orgId]="orgId"
          [registration]="registration"
          (previousClick)="onPreviousClick()"
        ></app-payment>
        <app-payment
          #confirmation
          *ngSwitchCase="steps.Confirmation"
          [orgId]="orgId"
          [registration]="registration"
          [paymentStatus]="paymentStatus"
        ></app-payment>
      </div>
    </div>
    <div *ngIf="currentStep != steps.Confirmation" class="mt-3 w-100">
      <div class="row">
        <div class="col">
          <p-button
            #prevBtn
            *ngIf="
              currentStep != steps.Payment && currentStep != steps.ExhibitorInfo
            "
            label="Back"
            [outlined]="true"
            [rounded]="true"
            (onClick)="onPreviousClick()"
          />
        </div>
        <div class="col text-end">
          <p-button
            #nextBtn
            *ngIf="currentStep != steps.Payment"
            label="Continue"
            [rounded]="true"
            [loading]="nextBtn.loading"
            (onClick)="onNextClick(nextBtn)"
          />
        </div>
      </div>
    </div>
  </div>
</section>
